import React, { useCallback } from "react";
import Container from "./style";

function Terms() {
  const termsInfo = [
    {
      title: `Personal data is information which relates to a person who has been, or could be, identified from it.
	  Examples may include a person’s name, address, email address and other personal details.`,
      content: []
    },
    {
      title: `The personal data of yours that we use includes:`,
      content: ["details we collect about you when you use our websites and apps","information provided when you use or receive our services, and","information we receive from other sources."]
    },
	{
		title: `We will usually be the ‘data controller’ responsible for how and why personal data is used. We may
		sometimes use personal data on behalf of another organisation, as that organisation’s ‘data
		processor’. In this case, that other organisation will explain how your personal data could be used.`,
		content: []
	  },
	  {
		title: `When you use or receive our products or services, we will sometimes need to give you additional
		information about how we will use your personal data. You should read this privacy notice with any
		other notice or information we provide.`,
		content: []
	  },
	  {
		title: `This privacy notice applies if you use any of our products or services. This includes using any of our
		websites (such as astar.ng, buy.pickorder) or apps. This policy also applies if you contact us or
		we contact you about our services by post, phone, email, text message, push notifications
		(automatic messages sent by apps) or other methods (including posts on websites and social-media
		platforms).`,
		content: []
	  },
	  {
		title: `Who do we share your personal data with?`,
		content: []
	  },
	  {
		title: `Our employees, or agents who act on our behalf, may use your data for the purposes set out in
		sections 3 and 4 above. For example, if you contact us with an enquiry or complaint, members of our
		Customer Service Team will see your information.`,
		content: []
	  },
	  {
		header:"Customers",
		title: `We share your personal data with our customers when we provide them with services which involve
		you. For example, if a customer has arranged for an item to be sent to you, we will give them
		delivery updates and proof that it has been delivered. This proof may confirm where we delivered
		the item and show any signature the person who received the item gave us.`,
		content: []
	  },
	  {header:"Online shopping platforms",
		title: `if we deliver items you have bought from an online platform using us to power logistics, we may
		share your personal data with them to provide updates on an item’s location and proof of delivery.`,
		content: []
	  },
	  {
		header: `Other organisations`,
		title:`We may share your data with other organisations if this is necessary as part of providing services to
		you or them. For example, we may share information with our technology providers and with the
		Post Office so that you can access our services (for example, when collecting a letter or parcel from
		your local Post Office branch). If you access our services through a smart-speaker or similar
		technology, we may also share your data with the organisations providing that technology so you
		can receive those services. We will also inform our app providers when you have downloaded any of
		our apps.`,
		content: []
	  },
	  {
		title: `We may also share your personal data with other organisations for legal purposes, to prevent or
		detect crime, or to protect someone’s rights, property or safety. These organisations include the
		police, law enforcement agencies and fraud-prevention agencies. This may include telling other
		organisations about addresses we will not deliver to or collect from.`,
		content: []
	  },

	  {
		title: `If you use our Redirection service, unless you ask us not to, we may sometimes sell information
		about you to help organisations update their contact details, or so specific types of organisation can
		
		send you offers that people moving home may be interested in. You will find more details, including
		information on how you can choose for us not to sell your information, in the terms and conditions
		for our Redirection service.`,
		content: []
	  },
	  {
		title: `We may pass your name, contact details (such as your email address), and details of your purchases
		from us, to organisations that help us with market research.`,
		content: []
	  },
	  {
		header:"Postal authorities and overseas carriers",
		title: `We will share your personal data with overseas postal authorities and carriers. If you are sending a
		letter or parcel overseas or receiving an item from overseas, we will provide the information
		required for customs and tax purposes or for security screening. This information will normally
		include:`,
		content: ["the sender’s name and address","the name and address of the person receiving the item, and","details of the item’s contents."]
	  },
	  {
		header:"Information required by law or regulation",
		title: `If required by any law or regulation, we may share your personal data with regulators such as the
		Information Commissioner.`,
		content: []
	  },
	  {
		title: `Cookies are text files placed on your computer when you use a website or app. When you use our
		websites and apps, we will ask you whether you agree to us using cookies to collect information
		about:`,
		content: ["the devices you use to access those websites and apps, and", "how you use those websites and apps (for example, the pages and content you’ve looked at)."]
	  },
	  {
		title: `It’s up to you whether to agree to us using cookies. For more details of the cookies we use, including
		cookies which help us to target advertising messages at you, please see the cookies policy on the
		website or app you are using.`,
		content: []
	  }
  ];

  
  return (
    <Container>
      <div className="Container">
        <div className="SectionParagraph"></div>

        <h1 className="Header">PRIVACY</h1>
        <div className="LastUpdated">
          <div style={{ color: "#fff" }}>
            <div style={{ marginBottom: 10 }}>
              We are committed to respecting your privacy and protecting your
              personal information (data) in line with current data protection
              laws. This privacy notice explains how we collect and use your
              personal data and tells you about your privacy rights.
            </div>
            <div>
              We’ve split the information into sections so that you can click
              through to the areas you need.
            </div>
          </div>
        </div>
        <h3 style={{ marginTop: 20, marginBottom: 20 }} className="IntroText">
         About us and our privacy notice This notice explains how we,
          astar.ng, use your personal data.
        </h3>
        <div>
          {termsInfo.map((r, id) => (
            <>
              <h2>{r.header}</h2>

              <li className="Section">
                <h3 className="SectionTitle">
                   {r.title}
                </h3>
				<ol>
                {r.content.map((data) => (
                  <li className="SectionParagraph">{data}</li>
                ))}
				</ol>
              </li>
            </>
          ))}
        </div>
      </div>
    </Container>
  );
}

export default Terms;
